import TIM from 'tim-js-sdk'
import COS from 'cos-js-sdk-v5'

let options={
    // SDKAppID:1600016314, // 测试
    // SDKAppID:1400432872, //正式的
    SDKAppID: process.env.VUE_APP_TIM_SDK_App_ID
};

let tim=TIM.create(options);
tim.setLogLevel(2);
tim.registerPlugin({'tim-upload-plugin':COS});

export {tim,TIM} 